import React from 'react';
import { SvgType } from '../svgType';

export default ({ color, className }: SvgType) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="31.5"
    height="31.5"
    viewBox="0 0 31.5 31.5"
  >
    <g transform="translate(1385.154 -4151)">
      <path
        d="M255.6.75a15,15,0,1,1-15,15,15,15,0,0,1,15-15"
        transform="translate(-1625 4151)"
        fill="#fff"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M270.355,13.148A14.986,14.986,0,0,0,255.6.751v15l-14.759-2.6a15.08,15.08,0,0,0-.241,2.6,15,15,0,0,0,30,0,15.081,15.081,0,0,0-.24-2.6"
        transform="translate(-1625 4151)"
        fill={color}
      />
    </g>
  </svg>
);
